export default "__VITE_ASSET__B07pDLAe__"